module.exports = __webpack_public_path__ + "static/media/dollar-circle2.35c738cf.svg";